import {Grid} from '@mui/material';
import {makeStyles} from '@mui/styles';
import styles from 'assets/jss/MainHeader';
import neFreeSense from 'assets/img/newLogo.svg'
import freeSense from 'assets/img/freesensHome.svg';
import CrmButton from 'components/Buttons/CrmButton';
import BackBtn from 'components/Buttons/BackBtn';
import UserInfoAccordion from 'components/Accordion/patientInfo/PatientInfoAccordion';
import Share from 'components/Modal/SahreModal';
const useStyles = makeStyles(styles);

const MainBanner = (props) => {
    const classes = useStyles();
    const {
        showCrmBtn,
        showLogo,
        showBackBtn,
        addPatientBackBtn,
        showUserAccorion,
        patientId,
        showShareModal,
        doctorName,
        editPatientProfile,
        loginBackButton,
        onActionHandler,
        fromScan
    } = props;

    const name = `${localStorage.getItem('firstName')} ${
        localStorage.getItem('lastName') ? localStorage.getItem('lastName') : ''
    } `;

    return (
        <Grid
            container
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row-reverse',
                margin: '24px 0',
                paddingX: '17px',
            }}>
            {/* left section */}
            <Grid item xs={2} display='flex' justifyContent='left'>
                {showBackBtn && (
                    <BackBtn
                        addPatientBackBtn={addPatientBackBtn}
                        loginBackButton={loginBackButton}
                        onActionHandler={onActionHandler}
                    />
                )}
            </Grid>
            {/* center ---- freesens Logo */}
            <Grid item textAlign='center' xs={8}>
                {showLogo  && (fromScan?<img src={neFreeSense} alt='' />:
                    <img src={freeSense} alt='' />)}
                {editPatientProfile && (
                    <span className={classes.textStyle}>ویرایش اطلاعات بیمار</span>
                )}
                {/* Accordion at Report component*/}
                <div
                    style={{
                        height: showUserAccorion && '1px',
                        width: '100%',
                    }}>
                    {showUserAccorion && (
                        <UserInfoAccordion patientId={patientId} />
                    )}
                </div>
                {/* Doctor Name at List component */}
                <span className={classes.textStyle}>{doctorName && name}</span>
            </Grid>
            {/* right section*/}
            <Grid item xs={2} display='flex' justifyContent='right'>
                {showCrmBtn && <CrmButton />}
                {showShareModal && <Share patientId={patientId} />}
            </Grid>
        </Grid>
    );
};

export default MainBanner;
